<template>
  <div class="main">
    <b-card>
      <b-card-body>
        <b-row>
          <b-col md="12" class="d-flex justify-content-end">
            <!-- <b-modal
              id="modal-add-event"
              ok-only
              ok-title="Add"
              centered
              size="lg"
              title="Add Event"
              :hide-footer="true"
              ref="addEvent"
            >
              <AddEvent @refresh="refreshData" />
            </b-modal> -->
            <b-button variant="primary" v-if="HasPermission(PermissionList.HRMS_Create)" v-b-modal.modal-add-event>
              <feather-icon icon="PlusIcon" class="mr-50" />
              New Event
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="2" sm="4" class="my-1">
            <b-form-group class="mb-0">
              <label class="d-inline-block text-sm-left mr-50">Per page</label>
              <b-form-select
                id="perPageSelect"
                v-model="perPage"
                size="sm"
                :options="pageOptions"
                class="w-50"
              />
            </b-form-group>
          </b-col>
          <b-col md="4" sm="8" class="my-1">
            <!-- <b-form-group
              label="Sort"
              label-cols-sm="3"
              label-align-sm="right"
              label-size="sm"
              label-for="sortBySelect"
              class="mb-0"
            >
              <b-input-group size="sm">
                <b-form-select
                  id="sortBySelect"
                  v-model="sortBy"
                  :options="sortOptions"
                  class="w-75"
                >
                  <template v-slot:first>
                    <option value="">-- none --</option>
                  </template>
                </b-form-select>
                <b-form-select
                  v-model="sortDesc"
                  size="sm"
                  :disabled="!sortBy"
                  class="w-25"
                >
                  <option :value="false">Asc</option>
                  <option :value="true">Desc</option>
                </b-form-select>
              </b-input-group>
            </b-form-group> -->
          </b-col>
          <b-col md="6" class="my-1">
            <b-form-group
              label="Filter"
              label-cols-sm="3"
              label-align-sm="right"
              label-size="sm"
              label-for="filterInput"
              class="mb-0"
            >
              <b-input-group size="sm">
                <b-form-input
                  id="filterInput"
                  v-model="filter"
                  type="search"
                  placeholder="Type to Search"
                />
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''">
                    Clear
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-table
              striped
              hover
              responsive
              :per-page="perPage"
              :current-page="currentPage"
              :items="items"
              :fields="fields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              :filter="filter"
              :filter-included-fields="filterOn"
              @filtered="onFiltered"
            >
            <template #cell(date)="data">
                {{ data.item.date ? formatDate(data.item.date) : '-' }}
              </template>

              <template #cell(status)="data">
                <b-badge :variant="status[1][data.value]">
                  {{ status[0][data.value] }}
                </b-badge>
              </template>

              <template v-slot:cell(actions)="data">
                <b-dropdown
                  variant="link"
                  toggle-class="p-0"
                  no-caret
                  class="m-1"  
                >
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="align-middle text-body"
                    />
                  </template>
                  <b-dropdown-item @click="editEventform(data.item)" :disabled="!IsAdmin()">
                    <feather-icon icon="EditIcon" />
                    <span class="align-middle ml-50">Edit</span>
                  </b-dropdown-item>
                  <b-dropdown-item  @click="deleteEvent(data.item.eventId)" :disabled="!IsAdmin()">
                    <feather-icon icon="TrashIcon" />
                    <span class="align-middle ml-50">Delete</span>
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>

            <b-modal id="modal-add-event" ok-only ok-title="Add" centered size="lg" title="Add Event"
            :hide-footer="true" ref="addEvent" @hide="resetForm">
            <validation-observer ref="formAddEvent" #default="{ invalid }">
            <b-form @submit.prevent="addEvent">
    <b-row>
      <b-col sm="6">
        <b-form-group label="Occasion Name" label-for="occasionName">
           <validation-provider rules="required" #default="{ errors }" name="title" vid="title">
          <b-form-input v-model="formData.title" name="title" placeholder="Occasion Name" />
          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label="Date" label-for="event_date">
          <validation-provider rules="required" #default="{ errors }" name="Date" vid="date">
          <b-form-datepicker
          v-model="formData.date" :max="today"
            id="date"
            placeholder="Choose a date"
            local="en"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
        </b-form-group>
      </b-col>
      <b-col sm="6">
  <b-form-group label="Status" label-for="status">
    <validation-provider rules="required" #default="{ errors }" name="status" vid="status">
      <b-form-select v-model="formData.status" :options="statusOptions" />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</b-col>
      <b-col sm="6">
        <b-form-group label="EventType" label-for="eventType">
          <validation-provider rules="required" #default="{ errors }" name="eventType" vid="eventType">
          <b-form-input v-model="formData.eventType" name="eventType" placeholder="Event Type" />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
        </b-form-group>
      </b-col>
      <b-col sm="6">
        <b-form-group label="Description" label-for="description">
          <validation-provider rules="required" #default="{ errors }" name="description" vid="description">
          <b-form-input v-model="formData.description" name="description" placeholder="Description" />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
        </b-form-group>
      </b-col>
      <!-- submit and reset -->
      <b-col md="12" class="d-flex justify-content-between">
        <!-- <b-button type="submit" @click="addEvent()" :disabled="submitting" variant="primary"
          >Save<b-spinner v-if="loading" class="mx-2"></b-spinner
        ></b-button> -->
        <b-button type="submit" @click="addEvent()" :disabled="submitting" variant="primary"
                        class="mr-2"><b-spinner small v-if="submitting"></b-spinner>
                        {{ submitting ? "Submitting..." : "Submit" }}
                      </b-button>
      </b-col>
    </b-row>
  </b-form>
</validation-observer>
            </b-modal>

            <b-modal ref="modaleditevent" id="modal-edit-event" title="Edit Event" size="lg" hide-footer
                    centered>
                    <validation-observer ref="formEditEvent" #default="{ invalid }">
            <b-form @submit.prevent="editEvent">
              <b-row>
      <b-col sm="6">
        <b-form-group label="Occasion Name" label-for="occasionName">
          <validation-provider rules="required" #default="{ errors }" name="title" vid="title">
          <b-form-input v-model="editformData.title" name="title" placeholder="Occasion Name" />
          <small class="text-danger">{{ errors[0] }}</small>
           </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label="Date" label-for="event_date">
          <validation-provider rules="required" #default="{ errors }" name="date" vid="date">
          <b-form-datepicker
          v-model="editformData.date" :max="today"
            id="date"
            placeholder="Choose a date"
            local="en"
            initial-date="2024-06-16"
          />
          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
        </b-form-group>
      </b-col>
      <b-col sm="6">
  <b-form-group label="Status" label-for="status">
    <validation-provider rules="required" #default="{ errors }" name="status" vid="status">
      <b-form-select v-model="editformData.status" :options="statusOptions" />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</b-col>
      <b-col sm="6">
        <b-form-group label="EventType" label-for="eventType">
          <validation-provider rules="required" #default="{ errors }" name="eventType" vid="eventType">
          <b-form-input v-model="editformData.eventType" name="eventType" placeholder="Event Type" />
          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
        </b-form-group>
      </b-col>
      <b-col sm="6">
        <b-form-group label="Description" label-for="description">
          <validation-provider rules="required" #default="{ errors }" name="description" vid="description">
          <b-form-input v-model="editformData.description" name="description" placeholder="Description" />
          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
        </b-form-group>
      </b-col>
      <!-- submit and reset -->
      <b-col md="12" class="d-flex justify-content-between">
        <b-button type="submit" @click="editEvent()" variant="primary"
          >Save<b-spinner v-if="loading" class="mx-2"></b-spinner
        ></b-button>
      </b-col>
    </b-row>
  </b-form>
</validation-observer>
            </b-modal>
          </b-col>

          <b-col cols="12">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="center"
              size="sm"
              class="my-0"
            />
            <b-form-group>
        Showing 
        {{ totalRows > 0 ? (perPage * (currentPage - 1) + 1) : 0 }} 
        to 
        {{ totalRows > 0 ? Math.min(perPage * currentPage, totalRows) : 0 }} 
        of 
        {{ totalRows > 0 ? totalRows : 0 }} 
        entries
      </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BSpinner,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCard,
  BDropdown,
  BLink,
  BDropdownItem,
  BTab,
  BTabs,
  BFormDatepicker,
} from "bootstrap-vue";
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
// import AddEvent from "./AddEvent.vue";
// import EditEvent from "./EditEvent.vue";
import { mapGetters, mapActions } from 'vuex';
import Swal from 'sweetalert2';
import { IsAdmin, HasPermission } from "@/@core/utils/validations/permissionCheck";
import { PermissionList } from "@/libs/defaultList";

extend('required', {
  ...required,
  message: 'This field is required'
});

export default {
  components: {
    BCard,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BSpinner,
    BDropdown,
    BLink,
    BDropdownItem,
    BTab,
    BTabs,
    // AddEvent,
    // EditEvent,
    BFormDatepicker,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      perPage: 5,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      filter: null,
      filterOn: [],
      fields: [
        { key: "title", label: "Occasion", sortable: true },
        { key: "date", label: "Date", sortable: true },
        { key: "actions", label: "Actions" },
      ],
      formData: {
        title: null,
        date: null,
        status: null,
        eventType: null,
        description: null
      },
      editformData: {
        eventId: null,
        title: null,
        date: null,
        status: null,
        eventType: null,
        description: null
      },
      statusOptions: [
      { value: null, text: "Select Status", disabled: true },
      { value: "active", text: "ACTIVE" },
      { value: "inactive", text: "INACTIVE" },
      
    ]
    };
  },
  computed: {
        ...mapGetters('eventModule', {
          items: 'event',
            loading: 'loading',
        }),
    },
    methods: {
      ...mapActions('eventModule', [
            'getEventListAction', 'addEventAction', 'removeEventAction', 'updateEventAction', 'getEventByIdAction'
        ]),

        formatDate(date) {
      const options = { year: "numeric", month: "short", day: "numeric" };
      return new Date(date).toLocaleDateString("en-US", options);
    },

    editEventform(item){
this.editformData = { ...item };
this.$refs.modaleditevent.show();
    },

    async deleteEvent(id) {
      //console.log("iffffffffffffffddddddddddddddddddddddd", id)
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.removeEventAction(id)
            .then(() => {
              this.$swal({
                icon: "success",
                title: "Deleted!",
                text: "Event has been deleted",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
              this.getEventListAction();
              this.totalRows = this.items.length;
            })
            .catch((error) => {
              this.$swal({
                icon: "error",
                title: "Error!",
                text: error,
                customClass: {
                  confirmButton: "btn btn-danger",
                },
              });
            });
        } else if (result.dismiss === "cancel") {
          this.$swal({
            title: "Cancelled",
            text: "Event is safe :)",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },

    async addEvent() {
      this.submitting = true;
      const isValid = await this.$refs.formAddEvent.validate();
      if (isValid) {
        try {
          const payload = {
            title: this.formData.title,
            date: this.formData.date,
            status: this.formData.status,
        eventType: this.formData.eventType,
        description: this.formData.description
          };
          console.log("payload", payload);
          await this.addEventAction(payload);
          this.successAdd();
         
          await this.getEventListAction()
          .then(() => {
            this.totalRows = this.items.length;
          this.$bvModal.hide("modal-add-event");
          this.resetForm();
          });
         
        } catch (error) { 
          this.errorAdd(error.response.data.message);
          this.$bvModal.hide("modal-add-event");
        }
      } else {
        this.submitting = false;
      }
    },

    async editEvent() {
      const isValid = await this.$refs.formEditEvent.validate();
      if (isValid) {
        try {
          const payload = {
            eventId: this.editformData.eventId,
            title: this.editformData.title,
            date: this.editformData.date,
            status: this.editformData.status,
            eventType: this.editformData.eventType,
            description: this.editformData.description,
          };
          console.log("edit payload", payload);

          await this.updateEventAction(payload);
          this.successEdit();
          
          await this.getEventListAction();
          this.totalRows = this.items.length;
          this.$bvModal.hide("modal-edit-event");
        } catch (error) {
          console.error(
            "Error in editEvent:",
            error.response || error.message || error
          );
          this.errorEdit(
            error.response ? error.response.data.message : error.message
          );
        }
      }
    },

    successAdd() {
      this.$swal({
        title: "Event Added!",
        text: "You have successfully added an Event!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    successEdit() {
      this.$swal({
        title: "Event Updated!",
        text: "You have successfully updated the Event!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    errorEdit(error) {
      this.$swal({
        title: "Error!",
        text: error ? error : " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    errorAdd(error) {
      this.$swal({
        title: "Error!",
        text: error ? error : " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    resetForm() {
      this.formData = {
        title: null,
        date: null,
        status: null,
        eventType: null,
        description: null
      };
      this.submitting = false;
    },
    },
    async mounted() {
        this.getEventListAction().then(() => {
            this.totalRows = this.items.length;
        });
    },
    setup(){
      return {
        IsAdmin,
        HasPermission,
        PermissionList
      }
    }
};
</script>
